var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(6 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9EBAF2",
    fillRule: "nonzero",
    d: "M13.3093125,0 C14.2352537,0 15.0914076,0.335161287 15.7813447,0.838120783 C16.2413028,1.17342711 16.7553532,1.88405352 17.3234958,2.97 L33.4125,2.97 C35.4878328,2.99285126 36.6965597,3.78245501 37.0386806,5.33881123 C37.0972806,5.60578941 36.9284393,5.86977551 36.6614795,5.92845908 C36.6265813,5.93613047 36.5909549,5.94 36.5552235,5.94 L0.51088154,5.94 C0.237500589,5.94 0.0158815405,5.71838095 0.0158815405,5.445 C0.0158815405,5.44482125 0.0158816373,5.4446425 0.0158818309,5.44446375 L0.0185625,2.97 L0.0185625,2.97 C0.0185625,1.37125532 1.60107235,0.0570067904 3.58270911,0.00180506246 L3.7125,0 L13.3093125,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9DBFF",
    d: "M0.51440445,6.93 L36.6105955,6.93 C36.8839765,6.93 37.1055955,7.15161905 37.1055955,7.425 C37.1055955,7.43134322 37.1054736,7.43768586 37.1052298,7.4440244 L36.208227,30.7660976 C36.1673374,31.829227 35.2936054,32.67 34.2296899,32.67 L2.89531011,32.67 C1.83139463,32.67 0.957662578,31.829227 0.916772984,30.7660976 L0.0197701691,7.4440244 C0.00926328558,7.17084543 0.222201085,6.9408726 0.495380055,6.93036572 C0.501718591,6.93012193 0.508061228,6.93 0.51440445,6.93 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectory);
export default __webpack_public_path__ + "static/media/Directory.34fd0326.svg";
export { ForwardRef as ReactComponent };